/* Zampa d'Oro · interazioni */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  // Componenti: ognuno si avvia sui propri elementi e si spegne quando l'editor del tema rimuove la sezione
  const components = [];
  let live = [];
  const component = (selector, init) => components.push({ selector, init, done: new WeakSet() });
  const mount = (scope) => {
    components.forEach((c) => {
      const els = [...scope.querySelectorAll(c.selector)];
      if (scope.matches && scope.matches(c.selector)) els.unshift(scope);
      els.forEach((el) => {
        if (c.done.has(el)) return;
        c.done.add(el);
        const ac = new AbortController();
        live.push({ el, ac });
        try { c.init(el, ac.signal); } catch (err) { console.error('[zdo]', c.selector, err); }
      });
    });
  };
  const unmount = (scope) => {
    live = live.filter(({ el, ac }) => {
      if (!scope.contains(el)) return true;
      ac.abort();
      return false;
    });
  };

  // Header che diventa pieno allo scroll
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Menu mobile: pulsante con aria-expanded, Esc per chiudere, il resto della pagina diventa inerte
  const menuBtn = document.querySelector('[data-menu-btn]');
  const menu = document.querySelector('[data-menu]');
  if (header && menuBtn && menu) {
    const mobile = window.matchMedia('(max-width: 720px)');
    const outside = [document.querySelector('#zdo-main'), document.querySelector('.zdo-footer'), document.querySelector('.zdo-skip')].filter(Boolean);
    menuBtn.hidden = false;
    const setOpen = (open, { focus = true } = {}) => {
      header.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('zdo-menu-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      outside.forEach((el) => { el.inert = open; });
      if (open && focus) {
        const first = menu.querySelector('a');
        if (first) first.focus();
      } else if (!open && focus) {
        menuBtn.focus();
      }
    };
    const isOpen = () => header.classList.contains('is-open');
    menuBtn.addEventListener('click', () => setOpen(!isOpen()));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });
    // Un link scelto chiude il menu prima che la pagina scorra alla sala
    menu.addEventListener('click', (e) => {
      if (e.target.closest('a') && isOpen()) setOpen(false, { focus: false });
    });
    // Se lo schermo si allarga oltre il mobile, il menu torna normale
    const onChange = () => { if (!mobile.matches && isOpen()) setOpen(false, { focus: false }); };
    if (mobile.addEventListener) mobile.addEventListener('change', onChange);
  }

  // Carrello: se la pagina torna dalla cache del browser (tasto Indietro), il numero potrebbe essere vecchio
  const cartLink = document.querySelector('[data-cart]');
  const setCartCount = (n) => {
    if (!cartLink) return;
    const count = cartLink.querySelector('[data-cart-count]');
    if (count) count.textContent = n;
    cartLink.setAttribute('aria-label', `Carrello, ${n} ${n === 1 ? 'articolo' : 'articoli'}`);
  };
  const refreshCart = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => { if (cart) setCartCount(cart.item_count); })
      .catch(() => {});
  };
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
  // Altri script (es. la pagina prodotto) possono annunciare un carrello aggiornato
  document.addEventListener('zdo:cart-updated', (e) => {
    if (e.detail && typeof e.detail.item_count === 'number') setCartCount(e.detail.item_count);
    else refreshCart();
  });

  // Comparsa allo scroll, con un piccolo ritardo a cascata dentro ogni sezione
  const revealIO = ('IntersectionObserver' in window && !reduceMotion && !designMode)
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;
  component('section, .zdo-gift__card', (block) => {
    block.querySelectorAll(':scope [data-reveal]').forEach((el, i) => el.style.setProperty('--d', `${Math.min(i, 6) * 0.09}s`));
  });
  component('[data-reveal]', (el, signal) => {
    if (!revealIO) { el.classList.add('is-in'); return; }
    revealIO.observe(el);
    signal.addEventListener('abort', () => revealIO.unobserve(el));
  });

  // Animazioni continue (CSS) in pausa quando la sezione è fuori dallo schermo
  const offscreenIO = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-offscreen', !entry.isIntersecting));
    }, { rootMargin: '200px 0px' })
    : null;
  component('#zdo-main section', (el, signal) => {
    if (!offscreenIO) return;
    offscreenIO.observe(el);
    signal.addEventListener('abort', () => offscreenIO.unobserve(el));
  });

  // Luce che segue il mouse nella hero
  component('[data-spotlight]', (spot, signal) => {
    if (!finePointer || reduceMotion) return;
    spot.addEventListener('pointermove', (e) => {
      const r = spot.getBoundingClientRect();
      spot.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
      spot.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
    }, { signal });
  });

  // Cornici che si inclinano verso il mouse
  component('[data-tilt]', (el, signal) => {
    if (!finePointer || reduceMotion) return;
    const base = el.classList.contains('zdo-medal') ? 'translateX(-60px) rotate(-8deg) ' : '';
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transition = 'transform .15s ease-out';
      el.style.transform = `${base}rotateY(${x * 10}deg) rotateX(${-y * 10}deg)`;
    }, { signal });
    el.addEventListener('pointerleave', () => {
      el.style.transition = '';
      el.style.transform = '';
    }, { signal });
  });

  // Polvere d'oro nella hero
  component('[data-dust]', (canvas, signal) => {
    if (reduceMotion || !canvas.getContext) return;
    const ctx = canvas.getContext('2d');
    let w = 0, h = 0, dpr = 1, specks = [], running = true, raf = 0;
    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.round(Math.min(90, (w * h) / 16000));
      specks = Array.from({ length: count }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.6 + 0.4,
        vx: (Math.random() - 0.5) * 0.12,
        vy: -(Math.random() * 0.25 + 0.05),
        a: Math.random() * Math.PI * 2,
      }));
    };
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const s of specks) {
        s.x += s.vx; s.y += s.vy; s.a += 0.02;
        if (s.y < -10) { s.y = h + 10; s.x = Math.random() * w; }
        if (s.x < -10) s.x = w + 10;
        if (s.x > w + 10) s.x = -10;
        const alpha = 0.25 + Math.sin(s.a) * 0.25 + 0.2;
        ctx.beginPath();
        ctx.fillStyle = `rgba(236, 210, 143, ${alpha})`;
        ctx.shadowColor = 'rgba(236, 210, 143, .8)';
        ctx.shadowBlur = 6;
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
      }
      if (running && !signal.aborted) raf = requestAnimationFrame(draw);
    };
    resize();
    draw();
    window.addEventListener('resize', resize, { signal });
    const io = new IntersectionObserver(([entry]) => {
      running = entry.isIntersecting;
      cancelAnimationFrame(raf);
      if (running) draw();
    });
    io.observe(canvas);
    signal.addEventListener('abort', () => { io.disconnect(); cancelAnimationFrame(raf); });
  });

  // Prima e dopo
  component('[data-compare]', (box, signal) => {
    const range = box.querySelector('[data-compare-range]');
    if (!range) return;
    range.addEventListener('input', () => box.style.setProperty('--pos', `${range.value}%`), { signal });
    const section = box.closest('section') || box;
    section.querySelectorAll('[data-compare-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        section.querySelectorAll('[data-compare-tab]').forEach((t) => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab);
        });
        box.querySelectorAll('[data-compare-set]').forEach((set) => set.classList.toggle('is-active', set.dataset.compareSet === tab.dataset.compareTab));
      }, { signal });
    });
    // Un piccolo movimento iniziale per far capire che si può trascinare
    if (!reduceMotion && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        let t = 0;
        const step = () => {
          if (signal.aborted) return;
          t += 0.02;
          const v = 50 + Math.sin(t * Math.PI * 2) * 22 * (1 - t);
          box.style.setProperty('--pos', `${v}%`);
          range.value = v;
          if (t < 1) requestAnimationFrame(step);
        };
        setTimeout(() => requestAnimationFrame(step), 500);
      }, { threshold: 0.5 });
      io.observe(box);
      signal.addEventListener('abort', () => io.disconnect());
    }
  });

  // QR decorativo sulla medaglietta
  component('[data-qr]', (qr) => {
    const n = 21;
    let seed = 7;
    const rand = () => (seed = (seed * 9301 + 49297) % 233280) / 233280;
    const finder = (x, y) => {
      for (const [fx, fy] of [[0, 0], [n - 7, 0], [0, n - 7]]) {
        const dx = x - fx, dy = y - fy;
        if (dx >= 0 && dx < 7 && dy >= 0 && dy < 7) {
          const edge = dx === 0 || dx === 6 || dy === 0 || dy === 6;
          const core = dx >= 2 && dx <= 4 && dy >= 2 && dy <= 4;
          return edge || core ? 1 : 0;
        }
        if (dx >= -1 && dx <= 7 && dy >= -1 && dy <= 7) return 0;
      }
      return null;
    };
    let html = '';
    for (let y = 0; y < n; y++) {
      for (let x = 0; x < n; x++) {
        const f = finder(x, y);
        const on = f === null ? rand() > 0.52 : f === 1;
        html += on ? '<i></i>' : '<i class="o"></i>';
      }
    }
    qr.innerHTML = html;
  });

  // Conto alla rovescia: a scadenza passata il riquadro sparisce, invece di restare fermo sugli zeri
  component('[data-countdown]', (box, signal) => {
    const end = new Date(box.dataset.countdown).getTime();
    if (Number.isNaN(end)) { box.hidden = true; return; }
    const units = { d: box.querySelector('[data-unit="d"]'), h: box.querySelector('[data-unit="h"]'), m: box.querySelector('[data-unit="m"]') };
    if (!units.d || !units.h || !units.m) return;
    let timer = 0;
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { box.hidden = true; clearInterval(timer); return; }
      units.d.textContent = Math.floor(left / 864e5);
      units.h.textContent = String(Math.floor((left % 864e5) / 36e5)).padStart(2, '0');
      units.m.textContent = String(Math.floor((left % 36e5) / 6e4)).padStart(2, '0');
    };
    tick();
    timer = setInterval(tick, 30000);
    signal.addEventListener('abort', () => clearInterval(timer));
  });

  mount(document);

  // Editor del tema: le sezioni ricaricate o rimosse riavviano e spengono i propri script
  document.addEventListener('shopify:section:load', (e) => mount(e.target));
  document.addEventListener('shopify:section:unload', (e) => unmount(e.target));
})();
